module.exports = __webpack_public_path__ + "img/4.5cd07e6f.png";